import React from 'react';
import {useSearchParams, Navigate} from 'react-router-dom';
import {Typography} from '@mui/material';
import ErrorCard from '../components/ErrorCard';
import {useSearchResult} from '../queries';
import {QueryProcessor} from '../components/QueryProcessor';

export const SearchNotFoundCard = ({keywords}: { keywords: string | null }) => {
    return (
        <ErrorCard title={'Search not found'} enableGoBack={true} sx={{width: 1}}>
            <Typography gutterBottom>Sorry! The following string you entered is invalid for search:</Typography>
            <Typography sx={{fontWeight: 'bold'}}>{keywords}</Typography>
        </ErrorCard>
    );
};

export const Search = () => {
    const [searchParams] = useSearchParams();
    const keywords = searchParams.get('keyword') ?? '';
    const keyword = keywords.trim().split(' ')[0];

    const enableQuery = keyword.length > 20 || !isNaN(Number(keyword));
    const searchQuery = useSearchResult(keyword, {enabled: enableQuery});
    if (!enableQuery) {
        return <SearchNotFoundCard keywords={keywords}/>;
    }

    if (!isNaN(Number(keyword))) {
        const blockHeight = Number(keyword);
        if (blockHeight >= 0 && blockHeight < 4_000_000) {
            return <Navigate to={`/block/${blockHeight}`} replace/>;
        }
    }

    return (
        <QueryProcessor
            query={searchQuery}
            dataValidator={(d: any) => d.type === 'search'}
            renderer={(d: any) => {
                if (d.payload.matches.length === 0) {
                    return <SearchNotFoundCard keywords={keywords}/>;
                }
                switch (d.payload.matches[0]) {
                    case 'block':
                        return <Navigate to={`/block/${d.payload.blockDetail.height}`} replace/>;
                    case 'tx':
                        return <Navigate to={`/tx/${d.payload.txDetail.txid}`} replace/>;
                    case 'address':
                        return <Navigate to={`/address/${d.payload.addressDetail.address}`} replace/>;
                    default:
                        return <SearchNotFoundCard keywords={keywords}/>;
                }
            }}
        />
    );
};

export default Search;
